const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

const sendMetric = (element, event) => {
    const url = element.dataset.sponsorshipMetricUrl;
    const placement = element.dataset.sponsorshipPlacement;

    if (!url || !placement || !csrfToken) {
        return;
    }

    const body = new FormData();
    body.append('_token', csrfToken);
    body.append('event', event);
    body.append('placement', placement);

    if (event === 'click' && navigator.sendBeacon) {
        navigator.sendBeacon(url, body);
        return;
    }

    fetch(url, {
        method: 'POST',
        body,
        credentials: 'same-origin',
        keepalive: event === 'click',
        headers: {
            'Accept': 'application/json',
        },
    }).catch(() => {
        // Sponsorship telemetry must never affect page navigation or browsing.
    });
};

const sponsoredPlacements = Array.from(document.querySelectorAll('[data-sponsorship-metric-url][data-sponsorship-placement]'));

if (sponsoredPlacements.length > 0) {
    const observed = new WeakSet();

    const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries, instance) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting || entry.intersectionRatio < 0.35 || observed.has(entry.target)) {
                    return;
                }

                observed.add(entry.target);
                sendMetric(entry.target, 'impression');
                instance.unobserve(entry.target);
            });
        }, { threshold: [0.35] })
        : null;

    sponsoredPlacements.forEach((element) => {
        if (observer) {
            observer.observe(element);
        } else {
            sendMetric(element, 'impression');
        }

        element.addEventListener('click', (event) => {
            if (event.target.closest('a[href]')) {
                sendMetric(element, 'click');
            }
        }, { capture: true });
    });
}
